import { render, staticRenderFns } from "./DetailsTableWidget.vue?vue&type=template&id=2e6299a8&scoped=true&"
import script from "./DetailsTableWidget.vue?vue&type=script&lang=js&"
export * from "./DetailsTableWidget.vue?vue&type=script&lang=js&"
import style0 from "./DetailsTableWidget.vue?vue&type=style&index=0&id=2e6299a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6299a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e6299a8')) {
      api.createRecord('2e6299a8', component.options)
    } else {
      api.reload('2e6299a8', component.options)
    }
    module.hot.accept("./DetailsTableWidget.vue?vue&type=template&id=2e6299a8&scoped=true&", function () {
      api.rerender('2e6299a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Statistics/TouchpointInfo/DetailsTableWidget.vue"
export default component.exports